<div class="clearfix public-help-page">
  <div class="container-fluid">
    <div class="clsTermConditions no-mar">
      <div class="clearfix mb-3">
        <a routerLink="/auth/login" class="public-help-back-link">← Back to Login</a>
      </div>

      <h1>Communication Portal Trainings and User Guides</h1>

      <p class="public-help-intro">
        Training videos and user guides for the Communication &amp; Operations Mobile Engagement Tool (COMET).
        Content is also available on the
        <a href="https://bss.wv.gov/community-provider-trainings" target="_blank" rel="noopener">
          Bureau for Social Services Community Provider Trainings
        </a>
        page.
      </p>

      <div class="clsCustomTab clearfix" role="application">
        <ul class="nav nav-tabs" id="publicHelpTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="faq-tab"
              type="button"
              role="tab"
              aria-controls="faq"
              aria-selected="false"
              (click)="onClick($event)"
              (keydown)="onKeydown($event)">
              FAQ
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="trainings-tab"
              type="button"
              role="tab"
              aria-controls="trainings"
              aria-selected="true"
              (click)="onClick($event)"
              (keydown)="onKeydown($event)">
              Trainings
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="user-guides-tab"
              type="button"
              role="tab"
              aria-controls="user-guides"
              aria-selected="false"
              (click)="onClick($event)"
              (keydown)="onKeydown($event)">
              User Guides
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-us-tab"
              type="button"
              role="tab"
              aria-controls="contact-us"
              aria-selected="false"
              (click)="onClick($event)"
              (keydown)="onKeydown($event)">
              Contact Us
            </button>
          </li>
        </ul>

        <div class="tab-content" id="publicHelpTabContent">
            <div class="tab-pane fade" id="faq" role="tabpanel" aria-labelledby="faq-tab">
              <app-faqs *ngIf="isFaq"></app-faqs>
          </div>
          <div class="tab-pane fade" id="trainings" role="tabpanel" aria-labelledby="trainings-tab">
            <app-video [showLoader]="true" *ngIf="isTrainings"></app-video>
          </div>

          <div class="tab-pane fade" id="user-guides" role="tabpanel" aria-labelledby="user-guides-tab">
            <app-user-guide [showLoader]="true" *ngIf="isUserGuides"></app-user-guide>
          </div>
          <div class="tab-pane fade" id="contact-us" role="tabpanel" aria-labelledby="contact-us-tab">
            <div class="clearfix clsContactPage">
              <div class="row w-100">
                <div class="col-sm-8 col-md-9 offset-md-2">
                  <div class="clearfix clsRightBlock">
                    <div class="clsInnerConternt">
                      <h2> Contact the Communication & Operations Mobile Engagement Tool Help Desk for assistance. </h2>
                    </div>
            
                  <div class="row justify-content-center align-items-stretch">
                      <div class="col-md-6 col-xl-6">
                        <div class="clearfix clsContactBox">
                          <em class="fa fa-envelope-o"></em>
                          <h3>Email Us</h3>
                            <h3>DoHS Employees:</h3>
                          <p>
                            <a href="mailto:osapathhelp@wv.gov">
                              osapathhelp&#64;wv.gov
                            </a>
                            <br>
                            </p>
                            <hr>
                            <h3>Non-DoHS Employees:</h3>
                        <a href="mailto:COMETTechHelp@wv.gov">
                          COMETTechHelp&#64;wv.gov
                        </a>
                        </div>
                      </div>

                      <div class="col-md-6 col-xl-6">
                        <div class="clearfix clsContactBox">
                          <em class="fa fa-phone"></em>
                          <h3>Help Desk</h3>
                          <p>
                            <a href="tel:3044140047">
                              304-414-0047
                            </a>
                            <br>
                            <small>(Available between 7am-5pm Eastern on work days)</small>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
